import type { InputValueTransformers } from '../types/InputValueTransformers';

import noConsecutiveSpaces from './handlers/noConsecutiveSpaces';

const inputValueTransformersMap: InputValueTransformers = {
  noConsecutiveSpaces,
};

export default inputValueTransformersMap;
